import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {Observable, of} from 'rxjs';
import {delay} from 'rxjs/operators';
import {DialogComponent} from './dialog.component';

@Injectable()
export class DialogService {
  constructor(public dialog: MatDialog,
              public snackBar: MatSnackBar) {
  }

  openProgressDialog(title: string, body?: string): MatDialogRef<DialogComponent> {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: {
        title: title,
        body: body ? body : 'Bitte warten...',
        disableClose: true,
        progressSpinner: true,
        icon: null,
        yesButton: false,
        noButton: false
      }
    });
    return dialogRef;
  }

  closeProgressDialogSuccess(dialog: MatDialogRef<DialogComponent>) {
    const data = dialog.componentInstance.data;
    data.body = 'Erfolreich.';
    data.disableClose = false;
    data.progressSpinner = false;
    data.icon = 'sync';
    data.iconStyle = {color: 'green', 'font-size': '48px'};
    of(null).pipe(delay(500)).subscribe(() => dialog.close());
  }

  closeProgressDialogError(dialog: MatDialogRef<DialogComponent>) {
    const data = dialog.componentInstance.data;
    data.body = 'Fehlgeschlagen!';
    data.disableClose = false;
    data.progressSpinner = false;
    data.icon = 'sync_problem';
    data.iconStyle = {color: 'red', 'font-size': '48px'};
  }

  openYesNoDialog(title: string, body: string): Observable<any> {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '250px',
      data: {
        title: title,
        body: body,
        disableClose: false,
        progressSpinner: false,
        yesButton: true,
        noButton: true
      }
    });
    return dialogRef.afterClosed();
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, null, {duration: 3000});
  }
}
